<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <!-- <pre>{{this.verrors}}</pre> -->
        <b-form @submit.prevent="updateDevice()">
            <b-row>
                <b-col sm=8>
                    <b-card>
                        <div slot="header">
                            <strong>Update Profile:</strong>
                        </div>
                        <div>
                            <b-form-group label="Name:" label-for="name" :label-cols-sm="3">
                                <b-form-input type="text" v-model="device.name" id="name" name="name" :state="validateState('name')" class="w-50" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('name')" class="invalid-feedback">{{ verrors.first('name') }}</div>
                            </b-form-group>
                            <b-form-group label="MAC:" label-for="mac" :label-cols-sm="4" class="w-50">
                                <b-form-input type="text" v-model="device.mac" v-validate="{ required: true, regex: /^(([A-Fa-f0-9]{2}[:]){5}[A-Fa-f0-9]{2}[,]?)+$/i }" id="mac" name="mac" :state="validateState('mac')" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('mac')" class="invalid-feedback">{{ verrors.first('mac') }}</div>
                            </b-form-group>
                            <b-form-group label="Serial #:" label-for="serial" :label-cols-lg="4" class="w-50">
                                <b-form-input type="text" v-model="device.serial" v-validate="'required'" id="serial" name="serial" :state="validateState('serial')" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('serial')" class="invalid-feedback">{{ verrors.first('serial') }}</div>
                            </b-form-group>
                            <b-form-group label="Model:" label-for="product_id" :label-cols-lg="4" v-if="product_opts.length != 0" class="w-50">
                                <b-form-select key="model" v-model="device.product_id" :options="product_opts" v-validate="'required'" id="product" name="product" value-field="id" text-field="name"  :disabled=!readonly>
                                </b-form-select>
                            </b-form-group>
                            <b-form-group label="Account:" label-for="account_id" :label-cols-lg="4" v-if="account_opts.length != 0" class="w-50">
                                <b-form-select key="account" v-model="device.account_id" :options="account_opts" v-validate="'required'" id="account_id" name="Account ID" value-field="id" text-field="name" :disabled=!readonly>
                                </b-form-select>
                            </b-form-group>
                            <b-form-group label="Default Profile:" label-for="profile" :readonly=!readonly>
                                <multiselect v-model="value" :options="options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="false" placeholder="search ..." :show-labels="false" label="name" track-by="id" :preselect-first="false" :hideSelected="false" :disabled=!readonly>
                                    <template slot="selection" slot-scope="{ values, search }">
                                    </template>
                                </multiselect>
                            </b-form-group>
                        </div>
                    </b-card>
                </b-col>
                <b-col sm=4>
                    <b-card>
                        <div slot="header">
                            <strong>Details</strong>
                        </div>
                        Info goes here
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm=8>
                    <div class="text-center">
                        <!-- TODO only activate when dirty -->
                        <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Save Profile</button>
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { vm } from '@/app.js'

export default {
    components: {
        Multiselect,
    },
    props: {
        device: {
            type: Object,
            default: function () {
                return {}
            }
        },
    },
    data() {
        return {
            profile: {},
            submitted: false,
            product_opts: [],
            account_opts: [],

            value: [],
            options: [],
            selectedIds: [],

            loading: 'true',
        };
    },
    // https://github.com/shentao/vue-multiselect/issues/263
    watch: {
        value(newValues) {
            this.selectedIds = newValues.map(obj => obj.id);
        }
    },
    created() {
        this.loading = true;
        let uri = `/api/devices/create`;
        axios.get(uri).then((response) => {
            this.product_opts = response.data.data.product_opts;
            let a = response.data.data.account_opts;
            if (!a || a.length === 0) {
                this.accounts_opts = [];
            } else {
                this.account_opts = a;
            }
            this.options = response.data.data.profile_opts;

            this.loading = false;
            this.value = this.device.configs;
        });
    },
    computed: {
        optionsArray() {
            return Object.keys(this.options).map(i => this.options[i]);
        },
        readonly() {
            return this.$can('device', 'edit')
        },
    },
    methods: {
        // toArray(obj_obj) {
        //   return Object.keys(obj_obj).map(i => obj_obj[i]);
        // },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.verrors.has(ref)
            }
            return null
        },

        updateDevice() {
            this.submitted = true;
            this.profile.id = this.device.id;
            this.profile.name = this.device.name;
            this.profile.mac = this.device.mac;
            this.profile.serial = this.device.serial;
            this.profile.product_id = this.device.product_id;
            this.profile.account_id = this.device.account_id
            this.profile.profile_list = this.selectedIds;

            this.$validator.validate().then(valid => {
                if (valid) {
                    let uri = `/api/devices/${this.device.id}/profile`;
                    axios.patch(uri, this.profile).then((response) => {

                            if (response.data.success === true) {
                                this.makeToast('info', 'Device updated.');
                                // setTimeout(function() {
                                //   window.location.href = '/#/devices';
                                // }, 1000);

                            } else {
                                this.makeToast('danger', 'Unable to update device.');
                            }
                        })
                        .catch(function (error) {
                            if (error.response && error.response.status == 422) {
                                vm.$setErrorsFromResponse(error.response.data);
                            }
                        });
                }
            });
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
            // toast.show();
        },
    }

}
</script>
